module.exports = __webpack_public_path__ + "static/img/zxfs.319480c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zxfs.jpg
// module id = RR3v
// module chunks = 1